
<div
  ref="tabBarItemRootRef"
  :class="
    classes(
      n(),
    )
  "
  :style="tabBarItemRootStyle"
  @click="onClick"
>
  <!-- 图标区 -->
  <div

    :class="
      classes(
        n('icon'),
        [activeStatus, n('icon--active')]
      )
    "
  >
    <component :is="icon" />
    <Badge
      v-show="badgeProps"
      v-bind="badgeProps"
      :class="classes(
        n('badge'),
        badgeOffsetClassName,
      )"
    />
  </div>
  <!-- 默认插槽（文本） -->
  <div
    :class="
      classes(
        n('label'),
        [activeStatus, n('label--active')]
      )
    "
  >
    <slot />
  </div>
</div>
